import {DEFAULT_SECTION, SUGGESTIONS_SECTION} from './constants';
import {transformFilters} from './transform-search-request';

/**
 * @param {import('custom-extensions/search/lib/api/types').SuggestRequest} request
 * @returns {{parameters: import('@constructor-io/constructorio-client-javascript').IAutocompleteParameters, query: string}}
 */
export const transformSuggestRequest = request => {
	const numResults = parseInt(request.size, 10) || 5;
	const {filters, preFilterExpression} = transformFilters(request.filters);

	return {
		parameters: {
			...filters
				? {filtersPerSection: {[DEFAULT_SECTION]: filters}}
				: {},
			...preFilterExpression
				? {preFilterExpressionPerSection: {[DEFAULT_SECTION]: preFilterExpression}}
				: {},
			resultsPerSection: {
				[DEFAULT_SECTION]: numResults,
				[SUGGESTIONS_SECTION]: numResults
			}
		},
		query: request.search || request.q || ''
	};
};
